import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BytesConversionPipe } from '@common-standalone/pipes/bytes-conversion.pipe';
import { SessionStorageProps } from '@commoncore/enums/sessionStorageProps';
import { GlobalService } from '@commoncore/services/global.service';
import { LocalStorageSvc } from '@commoncore/services/localStorage.service';
import { WRAPPER_TYPE } from '@commoncore/services/universal.service';
import { AppEvents, EventsList } from '@commoncore/utils/app-events';
import { UploadController } from '@core/controller/UploadController';
import { USER_DETAILS } from '@mainrepo/app/core/constants/Constants';
import { UPLOAD_CONS } from '@mainrepo/app/core/constants/UploadConstants';
import { UploadQueueImpl } from '@mainrepo/app/core/implementation/UploadQueueImpl';
import { UploadNotificationService } from '@mainrepo/app/core/services/upload-notification.service';
import { CancelAllUploadsComponent } from '@mainrepo/app/shared-standalone-components/upload-files/cancel-all-uploads/cancel-all-uploads.component';
import { DependenciesModule } from '@modules/dependencies/dependencies.module';
import { DuplicateFolderPopupComponent } from '../duplicate-folder-popup/duplicate-folder-popup.component';
import { FolderNameNotSupportedForUploadComponent } from '../folder-name-not-supported-for-upload/folder-name-not-supported-for-upload.component';



@Component({
  standalone:true,
  selector: 'upload-component',
  templateUrl: './upload.component.html',
  styleUrls: ['./upload.component.scss'],
  imports:[DependenciesModule,BytesConversionPipe,FolderNameNotSupportedForUploadComponent,CancelAllUploadsComponent,DuplicateFolderPopupComponent]
})
export class UploadComponent implements OnInit, OnDestroy {

  fileToUpload: any;
  tractionId:string;
  timerStart:any;
  timerEnd: any;
  progress:number=0;
  fileReadingProgressStatus:string ='';
  fileUploadController: any;
  timeRemainingString: any;
  uploadQueue: any= ["1"];
  filesAndDirectories:any = [];
  showunderline = false;
  //reference to implementation class
  //implRef: any;
  uploadQueueImplRef: any;
  static uploadCompRef: any;
  public universalService:any;
  private localStorageSvc: LocalStorageSvc;
  public closeUploadModal: boolean = false;
  currentFolderKey:string = "";
  http:any;
  @ViewChild("fileUpload", {static: true}) fileUpload: ElementRef;
  files  = [];  
  @ViewChild("folderUpload", {static: true}) folderUpload: ElementRef;
  @ViewChild("fileUploadAlubm", {static: true}) fileUploadAlubm: ElementRef;
  @ViewChild("fileUploadMemory", {static: true}) fileUploadMemory: ElementRef;
  @ViewChild("fileUploadPhotos", {static: true}) fileUploadPhotos: ElementRef;
  @ViewChild("fileUploadVideos", {static: true}) fileUploadVideos: ElementRef;
  //@ViewChild("fileUploadAudios", {static: true}) fileUploadAudios: ElementRef;

  @Output() createFolderValidation = new EventEmitter();
  @Input() enableButton:boolean;
  loggerService: any;
  uploadObject:any;
  folderService:any;
  router:any;
  fileOpsService: any;
  listService: any;
  shareAccessService: any;
  uploadNotificationsService: any;
  sessionStorageService: any;

  constructor(public globalService:GlobalService, 
    private route: ActivatedRoute,
    private changeDetectorRef:ChangeDetectorRef) {
   

  }

  ngOnInit() { 
    
    UploadComponent.uploadCompRef=this;
    UploadComponent.uploadCompRef.setProps();
    UploadComponent.uploadCompRef.getContrlImplRef();
    UploadComponent.uploadCompRef.registeringEvents();
    UploadComponent.uploadCompRef.setPositionForUpload();
  }

  

  ngOnDestroy(){
    UploadComponent.uploadCompRef.fileUploadController.destroyInstance();
    
    UploadComponent.uploadCompRef.uploadQueueImplRef.resetUploadParams()
    UploadComponent.uploadCompRef.uploadQueueImplRef.closeUploadProgressBar()

  }

  getContrlImplRef(){ 
    UploadComponent.uploadCompRef.fileUploadController = UploadController.getInstance(this.globalService, this.changeDetectorRef);
    //UploadComponent.uploadCompRef.implRef = UploadComponent.uploadCompRef.fileUploadController.getImplementationReference();
   
    UploadComponent.uploadCompRef.uploadQueueImplRef = UploadQueueImpl.getInstance(this.globalService);
  }

   public setProps(){
    this.universalService = this.globalService.getUniversalServiceRef();
    this.loggerService = this.globalService.getLoggerServiceRef();
    this.localStorageSvc = this.globalService.getLocalStorageSvcRef();
    this.sessionStorageService = this.globalService.getSessionStorageSvcRef();
    this.http = this.globalService.getHttpClientRef();
    this.folderService = this.globalService.getFolderServiceRef();
    this.router = this.globalService.getRouterRef();
    this.fileOpsService = this.globalService.getFileOperationServiceRef();
    this.shareAccessService = this.globalService.getShareAccessServiceRef();
    this.uploadNotificationsService = UploadNotificationService.getInstance(this.globalService);
    this.listService = this.globalService.getListServiceRef();
  }

  
  public onUploadClick() {
    let fileUpload ;
    if(this.universalService.fileUploadMemory) {
      fileUpload = this.fileUploadMemory.nativeElement;
      this.universalService.fileUploadMemory = false;
    } else if(this.universalService.isAlbumsView){
       fileUpload = this.fileUploadAlubm.nativeElement;
    // } else if(this.universalService.fileUploadMimeType == 'photos'){  //Commented, as if we need in future, we can take a reference
    //   fileUpload = this.fileUploadPhotos.nativeElement;
    // } else if(this.universalService.fileUploadMimeType == 'videos'){
    //   fileUpload = this.fileUploadVideos.nativeElement;
    // } else if(this.universalService.fileUploadMimeType == 'audio'){
    //   fileUpload = this.fileUploadAudios.nativeElement;
    } else{
       fileUpload = this.fileUpload.nativeElement;
    }
    
    const uploadParams= this.getUploadParams();
    fileUpload.onchange = () => {  
      let nextFiles=[];
      for (let index = 0; index < fileUpload.files.length; index++) {  
        const file = fileUpload.files[index];  
        if(this.universalService.isAlbumsView && (file.type.includes("image/") ||  file.type.includes("video/"))){
          nextFiles.push(file);  
        }else{
          nextFiles.push(file);  
        }
      }
      UploadComponent.uploadCompRef.fileUploadController.uploadFiles(UploadComponent.uploadCompRef.files,nextFiles, uploadParams);
      fileUpload.value = '';
      this.openUploadProgressBar();
    };
    fileUpload.click(); 
    
  }


  public onUploadFolderClick() {
    var emptyFoldersArray = [];
    var notAllowedExt = UPLOAD_CONS.FILE_FORMATS['NOTALLOWED']

    const folderUpload = this.folderUpload.nativeElement;
    const uploadParams= this.getUploadParams();
    folderUpload.onchange = async (event) => {
      console.log("event",event);  
      this.filesAndDirectories = [];
      let allFiles = Array.from(folderUpload.files);
      if(this.universalService.browserDetails.browser.name == "Safari"){
        if(allFiles[0]["webkitRelativePath"] == "" && allFiles.length == 1){
          UploadComponent.uploadCompRef.fileUploadController.uploadFiles(UploadComponent.uploadCompRef.files,[allFiles[0]], uploadParams);
          return;
        }
        allFiles = await this.sortAllFiles(allFiles); // it is not giving heirarchy is a propert order, child hierarchy is coming bofore the parent, so doing a sort for the proper heirarchy
      }
      let largeFilesSize=0;
      let smallFilesSize=0;
      let notAllowedFilesCount = 0;
      allFiles.map((file)=>{ 
        if (notAllowedExt.indexOf(file["name"].toLowerCase()) >= 0) {
          notAllowedFilesCount++
          return
        }
        if(file["size"] >= UPLOAD_CONS.SMALL_FILE_SIZE_LIMIT){
          largeFilesSize = largeFilesSize +  file["size"];
        }else{
          smallFilesSize = smallFilesSize +  file["size"];
        }
        var folderName = ""
        var folders = file["webkitRelativePath"].split("/");
        folders.length = folders.length - 1;
        folders.map((folder,index)=>{
          folderName = folderName + folder + "/";
          if(folderName + file["name"] == file["webkitRelativePath"]){
            this.decideParent(folderName,folder,file,folders.length)
          }else{
            var checkInFilesAndDirsArray = this.filesAndDirectories.find((dir)=> dir["folder"] == folder && dir["folderKey"] == index+1)
            if(checkInFilesAndDirsArray){
              return
            }
            var findIfEmptyFolderAlreadyExists = emptyFoldersArray.find(ef=>ef["level"] == index && ef["path"] == folderName)
            if(!findIfEmptyFolderAlreadyExists){
              emptyFoldersArray.push({
                path:folderName,
                level:index,
                file:file["webkitRelativePath"]
              })
              var obj = { emptyFolder : true,size:0}
              this.decideParent(folderName,folder,obj,index+1)
            }
          }
        })
      })
      if(this.universalService.browserDetails.browser.name == "Safari"){  // it is not giving heirarchy is a propert order, child hierarchy is coming bofore the parent, so doing a sort for the proper heirarchy
        this.filesAndDirectories = await this.sortFilesAndDirectories(this.filesAndDirectories);
      }
      var folderSize = 0;
      this.filesAndDirectories.map(folder=>{
        folderSize = folderSize + folder["size"]
      })
      var obj = {
        name:this.filesAndDirectories[0]["folder"],
        newName:this.filesAndDirectories[0]["folder"],
        size:folderSize,
        IsFolder:true,
        uploadFromButtonClick:true,
        subfolders:this.filesAndDirectories,
        totalFilesCount:(allFiles.length - notAllowedFilesCount),
        largeFilesSize:largeFilesSize,
        smallFilesSize:smallFilesSize,
        totalSize:largeFilesSize+smallFilesSize

      }
      console.log("files and directories array==>>",this.filesAndDirectories,obj);
      var folderNameValid = this.folderNameValidation(obj);
      if(folderNameValid)
      this.startFolderUpload(obj)
      folderUpload.value = '';
    };
    folderUpload.click(); 
  }

  decideParent(folderName,folder,file,folderKey){
    var parentFolder = folderName.split("/");
    var parent;
    var index = parentFolder.lastIndexOf(folder);
    var uniqueKey = Math.random().toFixed(16).split('.')[1];
    if(index >= 0){
      if((index-1)>=0){
        parent = parentFolder[index-1];
      }else{
        parent = "root";
        uniqueKey = "0";
      }
    }
    this.setFolderContents(parent,folder,file,folderKey,uniqueKey);
  }

  setFolderContents(parent,folder,file,folderKey,uniqueKey){
    file["IsFolder"] = false;
    file["isFile"] = true;
    var find = this.filesAndDirectories.find(f=>f["folder"] == folder && f["parent"] == parent && f["folderKey"] && f["folderKey"] == folderKey);
    var filesAndDirectoriesIndex = this.filesAndDirectories.lastIndexOf(find);
    var parentKeyOccurance = this.filesAndDirectories.find(f=>f["parent"] == parent && f["folderKey"] == folderKey);
    var parentKeyIndex = this.filesAndDirectories.indexOf(parentKeyOccurance);
    var parentUniqueKey;
    if(parentKeyIndex >=0){
      parentUniqueKey = this.filesAndDirectories.length == 0 ? uniqueKey : this.filesAndDirectories[parentKeyIndex]["parentUniqueKey"]
    }else{
      parentUniqueKey = this.filesAndDirectories.length == 0 ? uniqueKey : this.filesAndDirectories[this.filesAndDirectories.length - 1]["uniqueKey"]
    }
    if(filesAndDirectoriesIndex == -1){
      var objects = [];
      var emptyFolder = false;
      if(file.emptyFolder){
        emptyFolder = true;
        objects = [];
        file["IsFolder"] = true;
        file["isFile"] = false;
      }else{
        objects.push(file);
        emptyFolder = false
      }
      this.filesAndDirectories.push({
        folder: folder,
        parent: parent,
        uniqueKey:uniqueKey,
        parentUniqueKey:parentUniqueKey,
        contents:objects,
        emptyFolder:emptyFolder,
        size:file["size"],
        isFolder:true,
        folderKey : folderKey
      })
    }else{
      var objects = [];
      objects = this.filesAndDirectories[filesAndDirectoriesIndex]["contents"];
      objects.push(file);
      this.filesAndDirectories[filesAndDirectoriesIndex]["contents"] = objects;
      this.filesAndDirectories[filesAndDirectoriesIndex]["size"] = this.filesAndDirectories[filesAndDirectoriesIndex]["size"] + file["size"];
    }
  }

  public cancelUpload(){
    UploadComponent.uploadCompRef.fileUploadController.cancelUploadRequest();
  }

  public resetUploadParams(){
    UploadComponent.uploadCompRef.files=[];
    UploadComponent.uploadCompRef.uploadQueueImplRef.resetUploadParams();
    this.universalService.uploadStorageFullError = false;
  }
 
  public cancelSingleUpload(file){
    file.cancelUpload();
  }
  public cancelAllUploads(){
    console.log("cancel all uploads ==>>",this.uploadQueueImplRef.uploadQueue);
    this.uploadQueueImplRef.popTypeDuringUpload = "cancelAllUploads";
  }

  async confirmCancel(decision){
    if(decision){
      await UploadComponent.uploadCompRef.uploadQueueImplRef.cancelAllUpload();
      if( UploadComponent.uploadCompRef.closeUploadModal){
        UploadComponent.uploadCompRef.closeUploadModal = false
        UploadComponent.uploadCompRef.closeUploadProgressBar();
      }
        
      this.universalService.showToast(UPLOAD_CONS["ERR"]["CANCEL_ALL_UPLOADS"],"error");
    }
    this.uploadQueueImplRef.popTypeDuringUpload = "";
    console.log("decision",decision)
  }

  public retrySingleUpload(file){
    if(this.universalService.isAlbumsView && file.albumNotSupproted){
      return false;
    }
    file.retryUpload();
  }

  public closeUploadProgressBar(){
    if(UploadComponent.uploadCompRef.uploadQueueImplRef.uploadInprocess){
      this.closeUploadModal = true
      this.cancelAllUploads()
    }else{
      // this.universalService.MarkNewObjArray = [];
      // UploadComponent.uploadCompRef.implRef.uploadStarted = false;
      // UploadComponent.uploadCompRef.implRef.initAllUploadParams();
      // UploadComponent.uploadCompRef.implRef.clearCloseProgressBarInterval();

      UploadComponent.uploadCompRef.files=[];
      UploadComponent.uploadCompRef.uploadQueueImplRef.resetUploadParams();
      this.universalService.uploadStorageFullError = false;
    
      UploadComponent.uploadCompRef.uploadQueueImplRef.closeUploadProgressBar()
    }

    

  }

  public openUploadProgressBar(){
    $('.progress_container').removeClass('hide');
    this.maxmizeUploadProgressBar();
  }

  public maxmizeUploadProgressBar(){
    if(document.getElementById("dwn_list")!=null && document.getElementById("dwn_list").style.display != 'none'){
      $("#dwn_list").slideUp('fast',function(){
        document.getElementById("uploadContainer").style.bottom = ''+document.getElementById("downloadComponent").getBoundingClientRect().height+'px'
      });
      $("#collapse_btn_dwn").addClass('hidden');
      $("#expand_btn_dwn").removeClass('hidden');
    }
    $("#progress_list").slideDown('fast');
    $("#expand_btn").addClass('hidden');
    $("#collapse_btn").removeClass('hidden');
    UploadComponent.uploadCompRef.uploadQueueImplRef.clearCloseProgressBarInterval();
    // UploadComponent.uploadCompRef.implRef.clearMinimizeProgressBarInterval();
  }

  public minimizeUploadProgressBar(){
    $("#progress_list").slideUp('fast');
    $("#collapse_btn").addClass('hidden');
    $("#expand_btn").removeClass('hidden');
    // UploadComponent.uploadCompRef.implRef.clearCloseProgressBarInterval();
  }

  public droppedFilesUpload(event, filesAndDirectories, files) {
    let currentFolderKey = this.sessionStorageService.getCurrentFolderkey(true)
    var userData = this.localStorageSvc.getUserData(true);
    currentFolderKey = currentFolderKey ? currentFolderKey : userData["rootFolderKey"];
    const uploadParams= this.getUploadParams();
    var obj = {
      "name":files[0]["name"].trim(),
      "newName":files[0]["name"].trim(),
      "filesAndDirectories":filesAndDirectories,
      "files":files,
      "uploadParams":uploadParams
    }
    if(files[0]["IsFolder"]){
      var folderNameValid = this.folderNameValidation(obj);
      if(folderNameValid){
        this.startFolderUpload(obj)
      }
    }else{
      this.startFolderUpload(obj)
    }
  }


  getUploadParams(){
    if(this.universalService.isAlbumsView){
      // console.log(" route", this.route.snapshot.firstChild.params.id);
      // const albumKey = this.route.snapshot.firstChild.params.id;
      let albumtype = this.router.url.includes('/myalbums') ? 'myalbums' : 'sharedalbums'
      console.log("Route:", window.location.pathname.split('/').pop());
      const albumKey = window.location.pathname.split('/').pop();
      return  { boardKey:albumKey,boardName:this.universalService.currentAlbum["boardName"],locationOfUpload:"album",currentFolderKey:albumKey,albumtype:albumtype}
    } else if(this.universalService.destinationFolder && this.universalService.destinationFolder["objectKey"]){
      this.localStorageSvc.setFolderDataInWhichUploadIsInitiated(JSON.stringify(this.universalService.destinationFolder));
      var objectKey = this.universalService.destinationFolder["objectKey"]
      var objectName = this.universalService.destinationFolder["objectName"]
      var uploadParams = { currentFolderKey:objectKey,currentFolderName:objectName,locationOfUpload:(this.universalService.currentTab == 'sharedFiles') ? (this.router.url.includes("sharedbyme") ? "sharedbyme" : "sharedwithme") : this.universalService.currentTab};
      if(uploadParams["locationOfUpload"] == "Home" || uploadParams["currentFolderKey"] == USER_DETAILS["USER_DETAILS"]["rootFolderKey"] || uploadParams["locationOfUpload"] == "DigiLocker" || uploadParams["locationOfUpload"] == "JioPhoneCallAI"){
        uploadParams["locationOfUpload"] = "allfiles";
      }
      if(this.universalService.destinationFolder["tfKey"] && this.router.url.includes('/teamfolders')){
        uploadParams["tfKey"] = this.universalService.destinationFolder["tfKey"];
        uploadParams["tfName"] = this.universalService.destinationFolder["tfName"];
        uploadParams["currentTFObjectKey"] = this.universalService.currentTeamFolder["objectKey"];
      }
      return uploadParams;
    }else{
      var userData = this.localStorageSvc.getUserData(true);
      const rootFolderKey = userData["rootFolderKey"]
      let currentFolderKey = this.sessionStorageService.getCurrentFolderkey(true);
      const privateRootFolderKey = this.localStorageSvc.getPrivateFolderKey();
      if(this.router.url.includes("teamfolders") && this.universalService.currentTeamFolder && this.universalService.allowUpload) {
        currentFolderKey = this.sessionStorageService.getNestedTeamFolderkey();
      } else if(this.router.url.includes("privatefolder")) {
        currentFolderKey = this.sessionStorageService.getCurrentPrivateFolderKey();
      } else {
        currentFolderKey = currentFolderKey ? currentFolderKey : rootFolderKey;
      }

      if(currentFolderKey != rootFolderKey){
        this.localStorageSvc.setFolderDataInWhichUploadIsInitiated(JSON.stringify(this.folderService.currentFolder));
      }else{
        this.localStorageSvc.setFolderDataInWhichUploadIsInitiated(null);
      }
      var uploadParams = { currentFolderKey:currentFolderKey,currentFolderName:(currentFolderKey == rootFolderKey ? "JioCloud" : (currentFolderKey == privateRootFolderKey ? "Private Folder" : this.folderService.currentFolderName)),locationOfUpload:(this.universalService.currentTab == 'sharedFiles') ? (this.router.url.includes("sharedbyme") ? "sharedbyme" : "sharedwithme") : this.universalService.currentTab}
      if(uploadParams["locationOfUpload"] == "Home" || uploadParams["currentFolderKey"] == USER_DETAILS["USER_DETAILS"]["rootFolderKey"] || uploadParams["locationOfUpload"] == "DigiLocker" || uploadParams["locationOfUpload"] == "JioPhoneCallAI"){
        uploadParams["locationOfUpload"] = "allfiles";
      }
      if(this.router.url.includes('/teamfolders') && this.universalService.allowUpload){
        uploadParams["tfKey"] = this.universalService.currentTeamFolder["tfKey"];
        uploadParams["tfName"] = this.universalService.currentTeamFolder["tfName"];
        uploadParams["currentTFObjectKey"] = this.universalService.currentTeamFolder["objectKey"];
      }

      if(this.router.url.includes('/shared/') && this.universalService.allowUpload){
        uploadParams["shareKey"] = this.folderService.currentFolder["shareKey"];
        uploadParams["currentSharedFolder"] = this.shareAccessService.currentSharedFolder ? this.shareAccessService.currentSharedFolder : this.folderService.currentFolder;
        uploadParams["sharedFolder"] = this.folderService.currentFolder;
      }



      uploadParams["operationsWrapper"] = this.universalService.currentFileOpsWrapper;
      uploadParams["versioningSupported"] = this.universalService.manageVersionsSupportedInModule;
      uploadParams["officeForWebSupported"] = this.universalService.MSOfficeSupportedInModule;
      if(!this.universalService.allowUpload){
        uploadParams["currentFolderKey"] = USER_DETAILS["USER_DETAILS"]["rootFolderKey"];
        uploadParams["locationOfUpload"]= "allfiles";
        uploadParams["operationsWrapper"] = WRAPPER_TYPE.MY_FILES_OPERATIONS;
        uploadParams["currentFolderName"] = "JioCloud"
      }
      return uploadParams;
    }
  }
 
  public cancelFolderUpload(folder){
    folder.cancelUpload(folder);
  }

  folderNameValidation(obj){
    let self = this
    var regex =  /[/\/\\/<>:"|?*]/;
    if(obj["uploadFromButtonClick"]){
      var directories = obj["subfolders"];
      directories.map((dir)=>{
        var regex = new RegExp(/[/\/\\/<>:"|?*]/, 'g')
        dir["folder"] = dir["folder"].trim().replace(regex,'_');
        dir["parent"] = dir["parent"].trim().replace(regex,'_');
      })
      console.log("renamed subfolders=>>",directories)
    }
    if(obj["name"].match(regex)){
      self.uploadQueueImplRef.popTypeDuringUpload = "folderNotSupported";
      self.uploadQueueImplRef.folderForUpload = obj;
      return false;
    }else{
      this.uploadQueueImplRef.popTypeDuringUpload = "";
      return true
    }
  }

  startFolderUpload(obj){
    if(!obj){
      this.uploadQueueImplRef.popTypeDuringUpload = "";
      this.uploadQueueImplRef.folderForUpload = {};
      return
    }
    this.uploadQueueImplRef.popTypeDuringUpload = "";
    if(obj["uploadFromButtonClick"]){
      const uploadParams= this.getUploadParams();
      var object = [obj]
      UploadComponent.uploadCompRef.fileUploadController.folderUploadOnButtonClick(object,uploadParams);
    }else{
      obj["files"][0]["newName"] = obj["name"].trim();
      obj["filesAndDirectories"][0]["newName"] = obj["name"]; 
      if(this.universalService.downloadInProgress){
        document.getElementById("uploadContainer").style.bottom = ''+document.getElementById("downloadComponent").getBoundingClientRect().height+'px';
      }
      UploadComponent.uploadCompRef.uploadQueueImplRef.uploadStarted=true;
      //this.maxmizeUploadProgressBar();
     // UploadComponent.uploadCompRef.implRef=UploadComponent.uploadCompRef.fileUploadController.getFolderUploadImplementationReference();
      UploadComponent.uploadCompRef.fileUploadController.droppedFilesUpload(obj["filesAndDirectories"], obj["files"], obj["uploadParams"]);
    }
  }

  validateBeforeCreatingFolder(value){
    console.log("value of folder name from upload component",value)
    this.createFolderValidation.emit(value)
  }

  decisionTakenForDuplicateFolders(merge){
    var index = UploadComponent.uploadCompRef.uploadQueueImplRef.processingIndex;
    UploadComponent.uploadCompRef.uploadQueueImplRef.uploadQueue[index]["folderType"] = merge;
    UploadComponent.uploadCompRef.uploadQueueImplRef.uploadQueue[index]["mergeWaiting"] = false;
    UploadComponent.uploadCompRef.uploadQueueImplRef.uploadQueue[index]["errorPopUp"] = false;
    UploadComponent.uploadCompRef.uploadQueueImplRef.resetFolderPropertiesAsPerUserSelectionOnDuplicateFolder(UploadComponent.uploadCompRef.uploadQueueImplRef.uploadQueue[index])
    UploadComponent.uploadCompRef.uploadQueueImplRef.uploadInprocess = false;
    UploadComponent.uploadCompRef.uploadQueueImplRef.popTypeDuringUpload = "";
    UploadComponent.uploadCompRef.uploadQueueImplRef.startUpload(index)

    /*

    var index = this.implRef.folderForUpload["index"];
    this.implRef.uploadQueue[index]["folderType"] = merge;
    this.implRef.uploadQueue[index]["errorPopUp"] = false;
    this.implRef.resetFolderPropertiesAsPerUserSelectionOnDuplicateFolder(this.implRef.uploadQueue[index])
    this.implRef.uploadInprocess = false;
    this.implRef.startFolderUpload(this.implRef.uploadQueue,index)
    this.implRef.popTypeDuringUpload = "";
    */
  }

  noActionOnDuplicateFolderPopUp(){
    console.log("uploadQueueImplRef.uploadInprocess::",UploadComponent.uploadCompRef.uploadQueueImplRef.uploadInprocess)
    var index = UploadComponent.uploadCompRef.uploadQueueImplRef.processingIndex;
    UploadComponent.uploadCompRef.uploadQueueImplRef.updateFolderPropertiesOnErr(UploadComponent.uploadCompRef.uploadQueueImplRef.uploadQueue[index]);
    UploadComponent.uploadCompRef.uploadQueueImplRef.popTypeDuringUpload = "";
    setTimeout(() => {
      if(!UploadComponent.uploadCompRef.uploadQueueImplRef.isAnyFileWaiting() && UploadComponent.uploadCompRef.uploadQueueImplRef.isUploadQueueEmpty()){
        if(UploadComponent.uploadCompRef.uploadQueueImplRef.uploadQueue.length == 0)
          UploadComponent.uploadCompRef.uploadQueueImplRef.closeUploadProgressBar()
      }else{
        UploadComponent.uploadCompRef.uploadQueueImplRef.uploadQueue[index]["errorPopUp"] = false;
        UploadComponent.uploadCompRef.uploadQueueImplRef.startUpload(index+1)
      }
    }, 2000);

    /*this.implRef.uploadInprocess = false;
    this.implRef.updateFolderPropertiesOnErr(this.implRef.folderForUpload);
    this.implRef.next(this.implRef.folderForUpload);
    this.implRef.updateFolderPropertiesOnErr(this.implRef.folderForUpload)
    this.implRef.popTypeDuringUpload = "";
    setTimeout(() => {
      if(!this.implRef.isAnyFileWaiting() && this.implRef.isUploadQueueEmpty()){
        this.closeUploadProgressBar()
      }else{
        var index = this.implRef.folderForUpload["index"];
        this.implRef.uploadQueue[index]["errorPopUp"] = false;
        this.implRef.startFolderUpload(this.implRef.uploadQueue,index)
      }
    }, 2000);*/
  }

  private registeringEvents(){
    this.loggerService.log("registeringEvents for upload")
    let classRef = UploadComponent.uploadCompRef.uploadQueueImplRef;
    AppEvents.on(EventsList.CONNECTIONRESTORED_EVENT, function(){
      classRef.connectionRestored(classRef)
    })
    AppEvents.on(EventsList.CONNECTIONDOWN_EVENT, function(){
      classRef.connectionDown(classRef)
    })

    AppEvents.on(EventsList.UPLOAD_CLICKED, function(){
      UploadComponent.uploadCompRef.onUploadClick();
    })
  AppEvents.on(EventsList.UPLOAD_FOLDER_CLICKED, function(){
      UploadComponent.uploadCompRef.onUploadFolderClick()
    })

    AppEvents.globalObservable.subscribe(response => {
      if(response["closeAll"]) return;
      if(response["continueFileOperation"]){
        if(response["type"] == "Upload"){
          UploadComponent.uploadCompRef.droppedFilesUpload(this.uploadObject["event"], this.uploadObject["droppedFileReadersArray"], this.uploadObject["droppedFilesArray"]);
        }
        return;
      }
      if(response["FileOpType"] && response["FileOpType"] == "move") return;
      var destinationFolder = this.universalService.destinationFolder;
      if(destinationFolder && destinationFolder["objectName"]){
        if(destinationFolder["shareType"] == 'R' && destinationFolder["isShared"]){
          this.uploadObject = response;
          AppEvents.optionSelected.next({"showChangeAccessConfirmation":true,"buttonName":"Upload","noOfFiles":this.uploadObject["droppedFileReadersArray"].length})
          return;
        }
      }
      if(response["event"] || response["droppedFileReadersArray"] || response["droppedFilesArray"]) // added this condition because this observable is getting triggered for evry emit.
      UploadComponent.uploadCompRef.droppedFilesUpload(response["event"], response["droppedFileReadersArray"], response["droppedFilesArray"]);
    })
  }
  setPositionForUpload() {
    var downloadCont = document.getElementById("downloadComponent");
    if(document.getElementById("dwn_list")==null && downloadCont != undefined){
      document.getElementById("uploadContainer").style.bottom = ''+document.getElementById("downloadComponent").getBoundingClientRect().height+'px';
    }
  }

  sortFilesAndDirectories(allFiles){
    var allIndexes = [];
    allFiles.map((dir,dirIndx)=>{
      allIndexes = [];
      if(dir["parent"] == "root" && dir["uniqueKey"] == 0){
        dir["parentUniqueKey"] = "0";
      }else{
        allFiles.filter((f,indx)=>{
          if(f["folder"] == dir["parent"] && dir.folderKey != f["folderKey"]){
            allIndexes.push(indx)
          }
        })
        allIndexes.map(i=>{
          if(i<dirIndx){
            dir["parentUniqueKey"] = allFiles[i]["uniqueKey"]
          }
        })
      }
    })
    console.log("sorted data -->",allFiles)
    return allFiles;
  }

  confirmFileOperation(confirm){
    if(confirm){
      UploadComponent.uploadCompRef.droppedFilesUpload(this.uploadObject["event"], this.uploadObject["droppedFileReadersArray"], this.uploadObject["droppedFilesArray"]);
    }
    this.uploadQueueImplRef.popTypeDuringUpload = "";
  }

  sortAllFiles(files){
    files.map(file=>{
      file.level = file["webkitRelativePath"].split("/").length - 1;
    })

    files.sort(function(file1, file2) {
      return file1.level - file2.level;
    });
    return files
  }


  openLocationOfFile(file,openFolder=false){
    let objectKey = undefined;
    this.fileOpsService.resetRequiredDataBeforeOpeningTheLocationOfSelectedFile();
    this.listService.deSelectAll(null);
    if(!openFolder){
      this.uploadNotificationsService.selectUploadedFileIfPresentInView(file);
      // this.uploadNotificationsService.setUploadedData(file,true,true);
    }
    if(file.locationOfUpload == 'teamfolders'){
      this.sessionStorageService.setCurrentTeamFolder({folderKey:file["currentFolderKey"],tfKey:file["tfKey"]});
      if(!this.router.url.includes(file.currentFolderKey)){
        this.globalService.getFolderServiceRef().initialiseBreadCrumbs('1', this.universalService.rootTeamFolderName, null);
        this.globalService.getFolderServiceRef().manageBreadCrumbs(file["currentTFObjectKey"], file["tfName"],{"objectName":file["name"]}, null);
      }
      objectKey = openFolder ? file["objectKey"] : file["currentFolderKey"]
      this.router.navigate(['/teamfolders', objectKey], { queryParams: { tfKey: file["tfKey"] } , queryParamsHandling: 'merge'});
    }else if(file.locationOfUpload == 'album'){
      this.router.navigate(['/albums', file.albumtype, file.boardKey]);
    }else if(file.locationOfUpload == 'PrivateFolder'){
      objectKey = openFolder ? file["objectKey"] : file["currentFolderKey"]
      this.router.navigate(['/privatefolder', objectKey], {state:{"initBreadCrumbs" : true}});
    }else if(file.locationOfUpload == 'sharedbyme' || file.locationOfUpload == 'sharedwithme'){
      objectKey = openFolder ? file["objectKey"] : file["currentFolderKey"]
      if(!this.router.url.includes(file.currentFolderKey)){
        this.globalService.getFolderServiceRef().initialiseBreadCrumbs('1', this.universalService.rootFolderNameSharedfiles, null);
        this.globalService.getFolderServiceRef().manageBreadCrumbs(file["currentSharedFolder"]["objectKey"], file["currentSharedFolder"]["objectName"],file["currentSharedFolder"], null);
      }
      this.shareAccessService.currentSharedFolder = file["currentSharedFolder"];
      this.localStorageSvc.setSharedFolder(file["sharedFolder"],true);
      this.sessionStorageService.setSessionProperty(SessionStorageProps.CURRENT_SHARED_FOLDER,file["currentSharedFolder"],true);
      this.router.navigate(['/shared',file.locationOfUpload, objectKey],{state:{"initBreadCrumbs" : true, shareKey:file["shareKey"]}});
    }else{
      objectKey = openFolder ? file["objectKey"] : file["currentFolderKey"]
      if(objectKey == USER_DETAILS["USER_DETAILS"]["rootFolderKey"] && this.universalService.openFolderContent){
        AppEvents.emit(EventsList.MYFILES_TABBED_VIEW);
      }
      this.router.navigate(["/allfiles", objectKey], {state:{"initBreadCrumbs" : true}});
    }

    // if(this.router.url.includes(objectKey)){
    //   AppEvents.selectUploadedFile.next({openlocation:true})
    // }
    console.log("file from upload Q",file);
  }


  openPreviewOfFile(file){
    if(this.universalService.showPreview && this.universalService.selectedFile && file["objectKey"] == this.universalService.selectedFile["objectKey"]) return
    this.fileOpsService.resetRequiredDataBeforeOpeningTheLocationOfSelectedFile();
    this.listService.deSelectAll(null);
    if (file.uploadDone && !file.alreadyExists) {
      this.universalService.selectedNodes = [];
      this.universalService.selectedFile = "fileFromUpload";
      this.universalService.showPreview = true;
      let obj = this.getUploadedModuleType(file,file.locationOfUpload)
      setTimeout(() => {
        this.universalService.openPreview(file)
        AppEvents.objectPreview.next({previewFromUpload:true,objectDetails:obj});
      });
    }
  }

  openFolder(file){
    if (file.uploadDone && !file.alreadyExists) {
      this.openLocationOfFile(file,true)
    }
  }

  populateHoveredFile(file){
    this.showunderline = file;
  }

  removeSelectedFile(file){
    this.showunderline = null;
  }


  getUploadedModuleType(obj,locationOfUpload){
    var object = {locationOfUpload:locationOfUpload};
    if(locationOfUpload == "teamfolders"){
      object["moduleType"] = "teamfolder";
      object["uploadInitiatedModule"] = "teamfolders"
      object["tfKey"] = obj["tfKey"];
      object["version"] = obj["version"];
    }else if(locationOfUpload == 'sharedbyme' || locationOfUpload == 'sharedwithme'){
      object["moduleType"] = "share";
      object["uploadInitiatedModule"] = "sharedFiles"
      object["shareKey"] = obj["shareKey"];
      object["version"] = obj["version"];
    }else if(locationOfUpload == 'album' ){
      object["moduleType"] = "albums";
      object["uploadInitiatedModule"] = "Album Details"
      object["boardKey"] = obj["boardKey"];
      object["version"] = obj["version"];
    }else{
      object["moduleType"] = "repo";
      object["objectKey"] = obj["objectKey"];
      object["version"] = obj["version"];
      object["uploadInitiatedModule"] = locationOfUpload;
    }
    object["objectKey"] = object["objectKey"] ? object["objectKey"] :  obj["objectKey"];
    object["operationsWrapper"] = obj["operationsWrapper"];
    object["versioningSupported"] = obj["versioningSupported"];
    object["officeForWebSupported"] = obj["officeForWebSupported"]
    return object;
  }


  
}
